// frontend/src/data/previewData.js

/* -----------------------------------------------------------
   PREVIEW USER
------------------------------------------------------------ */

export const PREVIEW_USER = {
  id: 9001,

  name: "Jade Kim",
  display_name: "Jade Kim",
  username: "thejadepillar",

  profile_pic_url: "/images/jadepropic1.jpg",

  bio:
    '"A jack of all trades is a master of none, but oftentimes better than a master of one."',

  /* ---------------------------------------------------------
     PROFILE EXTRAS
  ---------------------------------------------------------- */

  currently_exploring: [
    "ski",
    "pilates",
    "cooking",
    "pottery",
    "guitar",
  ],

  home_places: [
    "seoul",
    "nyc",
  ],

  /* ---------------------------------------------------------
     ON REPEAT

     This is a normal Spotify link, so it can work even in the
     logged-out preview. Clicking it simply opens Spotify.
  ---------------------------------------------------------- */

  on_repeat_type: "track",

  on_repeat_title: "Hand in My Pocket",

  on_repeat_artist: "Alanis Morissette",

  on_repeat_url:
    "https://open.spotify.com/track/1q2QpEOOPwnB4sHDjHqOq6",

  on_repeat_spotify_id:
    "1q2QpEOOPwnB4sHDjHqOq6",

  /* ---------------------------------------------------------
     SHOUTOUTS
  ---------------------------------------------------------- */

  flowers_enabled: true,

  /* ---------------------------------------------------------
     STATS
  ---------------------------------------------------------- */

  activitiesCount: 212,

  followers: 85,

  following: 42,

  /* ---------------------------------------------------------
     LATEST ACTIVITY
  ---------------------------------------------------------- */

  latest_activity_title:
    "At-home wine tasting #3",
};


/* -----------------------------------------------------------
   PREVIEW SHOUTOUTS

   Mirrors FLOWER_PROMPTS exactly:
   - same prompt keys
   - same prefixes
   - same body text as each prompt's placeholder
   - same order

   This intentionally includes all prompts so the preview
   shoutout wall can demonstrate pagination / page 2.

   ShoutoutWallModal can receive these through
   shoutoutsOverride so the preview never needs to call the API.

   Valid font IDs:
   - walter-turncoat
   - comfortaa
   - short-stack
   - dyna-puff
   - pangolin
   - indie-flower
------------------------------------------------------------ */

export const PREVIEW_SHOUTOUTS = [
  {
    id: 9901,

    prompt_key: "proud",

    prefix: "I'm proud of you for",

    body: "not letting the 5 a.m. alarm win",

    is_public: true,

    hidden_by_recipient: false,

    font_id: "walter-turncoat",

    sender: {
      id: 9002,
      name: "Maya Rodriguez",
      display_name: "Maya Rodriguez",
      username: "mayamoves",
      profile_pic_url:
        "/images/mayapropic2.png",
    },
  },

  {
    id: 9904,

    prompt_key: "rockstar",

    prefix: "You are",

    body: "Barry's #1 draft pick",

    is_public: true,

    hidden_by_recipient: false,

    font_id: "dyna-puff",

    sender: {
      id: 9006,
      name: "Yuna Moon",
      display_name: "Yuna Moon",
      username: "yunamoon",
      profile_pic_url:
        "/images/yunapropic1.jpg",
    },
  },

  {
    id: 9905,

    prompt_key: "dont_forget",

    prefix: "Don't forget",

    body: "how far you've already come",

    is_public: true,

    hidden_by_recipient: false,

    font_id: "pangolin",

    sender: {
      id: 9002,
      name: "Maya Rodriguez",
      display_name: "Maya Rodriguez",
      username: "mayamoves",
      profile_pic_url:
        "/images/mayapropic2.png",
    },
  },

  {
    id: 9914,

    prompt_key: "love_that",

    prefix: "I love that you",

    body: "never give up",

    is_public: true,

    hidden_by_recipient: false,

    font_id: "short-stack",

    sender: {
      id: 9004,
      name: "Aaliyah Harris",
      display_name: "Aaliyah Harris",
      username: "aharris214",
      profile_pic_url:
        "/images/aaliyahpropic1.jpg",
    },
  },

  {
    id: 9916,

    prompt_key: "thank_you",

    prefix: "Thank you for",

    body: "having my back",

    is_public: true,

    hidden_by_recipient: false,

    font_id: "walter-turncoat",

    sender: {
      id: 9006,
      name: "Yuna Moon",
      display_name: "Yuna Moon",
      username: "yunamoon",
      profile_pic_url:
        "/images/yunapropic1.jpg",
    },
  },

  {
    id: 9907,

    prompt_key: "remember",

    prefix: "I'll always remember",

    body:
      "conquering the impossible of playing tennis in NYC together",

    is_public: true,

    hidden_by_recipient: false,

    font_id: "short-stack",

    sender: {
      id: 9003,
      name: "Reeves Li",
      display_name: "Reeves Li",
      username: "danielli1225",
      profile_pic_url:
        "/images/reevespropic1.jpg",
    },
  },

  {
    id: 9909,

    prompt_key: "inspire",

    prefix: "You inspire me to",

    body: "be a little braver",

    is_public: true,

    hidden_by_recipient: false,

    font_id: "pangolin",

    sender: {
      id: 9005,
      name: "Dhruv Chatterjee",
      display_name: "Dhruv Chatterjee",
      username: "dhruvchat",
      profile_pic_url:
        "/images/dhruvpropic1.jpg",
    },
  },

  {
    id: 9908,

    prompt_key: "trust",

    prefix: "I'll trust you with",

    body: "picking the wine, always",

    is_public: true,

    hidden_by_recipient: false,

    font_id: "indie-flower",

    sender: {
      id: 9004,
      name: "Aaliyah Harris",
      display_name: "Aaliyah Harris",
      username: "aharris214",
      profile_pic_url:
        "/images/aaliyahpropic1.jpg",
    },
  },

  {
    id: 9913,

    prompt_key: "elite_at",

    prefix: "You're weirdly good at",

    body: "blending spices",

    is_public: true,

    hidden_by_recipient: false,

    font_id: "walter-turncoat",

    sender: {
      id: 9003,
      name: "Reeves Li",
      display_name: "Reeves Li",
      username: "danielli1225",
      profile_pic_url:
        "/images/reevespropic1.jpg",
    },
  },

  {
    id: 9906,

    prompt_key: "very_you",

    prefix: "The most you thing ever is",

    body: "reading a book on the treadmill",

    is_public: true,

    hidden_by_recipient: false,

    font_id: "short-stack",

    sender: {
      id: 9005,
      name: "Dhruv Chatterjee",
      display_name: "Dhruv Chatterjee",
      username: "dhruvchat",
      profile_pic_url:
        "/images/dhruvpropic1.jpg",
    },
  },

  {
    id: 9912,

    prompt_key: "most_likely_to",

    prefix: "Most likely to",

    body:
      "hit 100 Solidcore classes before the rest of us hit 25",

    is_public: true,

    hidden_by_recipient: false,

    font_id: "pangolin",

    sender: {
      id: 9002,
      name: "Maya Rodriguez",
      display_name: "Maya Rodriguez",
      username: "mayamoves",
      profile_pic_url:
        "/images/mayapropic2.png",
    },
  },

  {
    id: 9915,

    prompt_key: "better_because",

    prefix: "Life is better because you",

    body: "enable my most questionable decisions",

    is_public: true,

    hidden_by_recipient: false,

    font_id: "dyna-puff",

    sender: {
      id: 9006,
      name: "Yuna Moon",
      display_name: "Yuna Moon",
      username: "yunamoon",
      profile_pic_url:
        "/images/yunapropic1.jpg",
    },
  },
];


/* -----------------------------------------------------------
   OPTIONAL SHARED PREVIEW USERS

   These are useful if ExplorePreview, ActivityCard demos,
   shoutouts, circle members, etc. should all use the same
   reusable demo people.
------------------------------------------------------------ */

export const PREVIEW_USERS = {
  jade: PREVIEW_USER,

  maya: {
    id: 9002,
    name: "Maya Rodriguez",
    display_name: "Maya Rodriguez",
    username: "mayamoves",
    profile_pic_url:
      "/images/mayapropic2.png",
  },

  reeves: {
    id: 9003,
    name: "Reeves Li",
    display_name: "Reeves Li",
    username: "danielli1225",
    profile_pic_url:
      "/images/reevespropic1.jpg",
  },

  aaliyah: {
    id: 9004,
    name: "Aaliyah Harris",
    display_name: "Aaliyah Harris",
    username: "aharris214",
    profile_pic_url:
      "/images/aaliyahpropic1.jpg",
  },

  dhruv: {
    id: 9005,
    name: "Dhruv Chatterjee",
    display_name: "Dhruv Chatterjee",
    username: "dhruvchat",
    profile_pic_url:
      "/images/dhruvpropic1.jpg",
  },

  yuna: {
    id: 9006,
    name: "Yuna Moon",
    display_name: "Yuna Moon",
    username: "yunamoon",
    profile_pic_url:
      "/images/yunapropic1.jpg",
  },
};